import { Box } from '@material-ui/core';
import { RequestsPageLayout } from 'Layout/RequestsPageLayout';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import { offersAction } from 'store';
import { AVAILABLE, REQUESTED } from 'utils/constant';
import { dateValidFormat } from 'utils/helpers';
import { v4 as uuid } from 'uuid';
import {
  QuestionsBlock,
  QuestionContainer,
  SelectedQuestionInfo,
  RequestName,
  StatusAndDate,
  RequestStatus,
  QuestionsWrapper,
  EachQuestionContainer,
  QuestionText,
  AnswerText,
  RequestSubmitDate,
  RequestsWrapper,
} from './styled';

export const RequestQuestions = () => {
  const { offer } = useSelector((state) => state.offersReducer);

  const [searchParams] = useSearchParams();

  const { id } = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(offersAction.getOffer(id));
  }, [dispatch, id]);

  return (
    <RequestsPageLayout>
      <RequestsWrapper>
        <QuestionsBlock>
          <QuestionContainer>
            <SelectedQuestionInfo>
              <RequestName questionList>
                {!searchParams.get('title') ? searchParams.get('title') : 'Request'}
              </RequestName>

              <StatusAndDate>
                <RequestSubmitDate>
                  Submitted: {dateValidFormat(searchParams.get('submitted'))}
                </RequestSubmitDate>

                <RequestStatus
                  className={
                    searchParams.get('status') === 1 ? 'green-background' : ''
                  }
                >
                  {searchParams.get('status') === 1 ? AVAILABLE : REQUESTED}
                </RequestStatus>
              </StatusAndDate>
            </SelectedQuestionInfo>

            <QuestionsWrapper>
              {offer?.question?.map((item, index) => (
                <EachQuestionContainer key={uuid()}>
                  <QuestionText>
                    {index + 1}. {item.question}
                  </QuestionText>
                  <AnswerText>
                    {item.answer.map((i) => (
                      <Box key={uuid()}>{i}</Box>
                    ))}
                  </AnswerText>
                </EachQuestionContainer>
              ))}
            </QuestionsWrapper>
          </QuestionContainer>
        </QuestionsBlock>
      </RequestsWrapper>
    </RequestsPageLayout>
  );
};
